import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateResponsiveState, handleResizeEffect } from '../Store/slices/Responsive';

/**
 * ResponsiveProvider - A component that listens to window resize events
 * and updates the Redux store with the current window dimensions and responsive state
 */
const ResponsiveProvider = ({ children }) => {
    const dispatch = useDispatch();

    // Update responsive state based on window dimensions
    const updateDimensions = () => {
        dispatch(
            updateResponsiveState({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        );
        dispatch(handleResizeEffect());
    };

    useEffect(() => {
        // Set initial dimensions
        updateDimensions();

        // Add window resize listener
        window.addEventListener('resize', updateDimensions);

        // Clean up
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    return children;
};

export default ResponsiveProvider; 